<template>
  <b-form-input
    class="custom-input-obj" 
    id="myURL" 
    name="myURL" 
    type="url" 
    v-model.lazy.trim="valueHandler"
    v-on:click="onWindowsOpen()"
    :state="this.$props.state"
    :placeholder=" this.$props.placeholder ? this.$props.placeholder : 'LINK'"
  />
</template>

<script>
  export default {
    props: [
      "value",
      "onChangedValue",
      "state",
      "placeholder"
    ],
    async mounted() {
      this.valueHandler = this.$props.value;
    },
    watch: {
      valueHandler(value) {
        if (value) {
          this.$props.onChangedValue(value);
        }
      },
    },
    data() {
      return {
        valueHandler: null,
      }
    },
    methods: {
      onWindowsOpen() {
        if (this.valueHandler != null && this.valueHandler != "") {
          window.open(this.valueHandler, "_blank");
        }
      },
    }
  }
</script>
<style lang="css" scoped>
input:hover {
  text-decoration: underline;
}
.custom-input-obj {
  border: 0 none !important;
  outline: 0;
  color: rgb(0, 153, 93) !important;
}
</style>
